import Components from '../Components';
export default function (el) {
	var registerEvent = () => {
		$(' [data-cart]', el).click((event) => {
			event.preventDefault();

			Components.loading(el);
			var element = $(event.currentTarget);

			sendAction(element);
		});
	}

	var sendAction = (element) => {
		$.ajax({
			method: "POST",
			url: wp.ajax_url,
			data: {
				action: 'sl_cart',
				data: {
					action: element.data('action'),
					id: element.data('cart'),
					art: element.data('art'),
				}
			}
		}).done((response) => {
			$(' .sl-config-print-prices', el).html(response);
			registerEvent();
			if(element.data('action') === 'delete' || element.data('action') === 'copy') {
				location.reload();
			} else {
				Components.loading(el, 'stop');
			}
		});
	}

	registerEvent();
}
